import { useParams } from "react-router-dom"
import { CompareEmptyState } from "routes/schedule/compare/compare-empty-state"
import { getCompareDestinationId } from "routes/schedule/compare/lib/get-compare-destination-id"

const messages = {
    destination: {
        title: "Your schedule is no longer available",
        detail: "It may have been deleted, or you may no longer have access to it.",
    },
    source: {
        title: "The version your schedule was created from is no longer available",
        detail: "It may have been removed, or you may not have access to it, so its changes can't be compared.",
    },
    other: {
        title: "The original schedule is no longer available",
        detail: "It may have been deleted, or you may no longer have access to it.",
    },
}

export function MissingComparisonDocument({ missing }) {
    const { destination } = useParams()
    const { title, detail } = messages[missing]
    return <CompareEmptyState id={getCompareDestinationId(destination)} title={title} detail={detail} />
}
